import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;

const getOrCreateTabId = (): string => {
  const existing = sessionStorage.getItem("__call_tab_id");
  if (existing) return existing;
  const newId = Math.random().toString(36).slice(2);
  sessionStorage.setItem("__call_tab_id", newId);
  return newId;
};

export const TAB_ID = getOrCreateTabId();

export function getCallSocket(): Socket {
  if (!socket) {
    socket = io(process.env.REACT_APP_CALL_ORIGIN as string, {
      autoConnect: false,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
    });
  }
  return socket;
}

export function destroyCallSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

const CALL_LOCK_KEY = "global_call_lock";
const LOCK_TTL_MS = 8000;
const HEARTBEAT_INTERVAL = 3000;

let heartbeatTimer: ReturnType<typeof setInterval> | null = null;

export function acquireCallLock(userId: string) {
  localStorage.setItem(
    CALL_LOCK_KEY,
    JSON.stringify({
      tabId: TAB_ID,
      userId,
      heartbeat: Date.now(),
    }),
  );

  heartbeatTimer = setInterval(() => {
    const current = getRawCallLock();
    if (current?.tabId === TAB_ID) {
      localStorage.setItem(
        CALL_LOCK_KEY,
        JSON.stringify({
          tabId: TAB_ID,
          userId,
          heartbeat: Date.now(),
        }),
      );
    } else {
      stopHeartbeat();
    }
  }, HEARTBEAT_INTERVAL);
}

export function releaseCallLock() {
  stopHeartbeat();
  const lock = getRawCallLock();
  if (lock?.tabId === TAB_ID) {
    localStorage.removeItem(CALL_LOCK_KEY);
  }
}

function stopHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
    heartbeatTimer = null;
  }
}

function getRawCallLock(): {
  tabId: string;
  userId: string;
  heartbeat: number;
} | null {
  try {
    const val = localStorage.getItem(CALL_LOCK_KEY);
    return val ? JSON.parse(val) : null;
  } catch {
    return null;
  }
}

export function getCallLock(): {
  tabId: string;
  userId: string;
  heartbeat: number;
} | null {
  const lock = getRawCallLock();
  if (!lock) return null;
  if (Date.now() - lock.heartbeat > LOCK_TTL_MS) return null;
  return lock;
}

export function cleanStaleLockIfExpired() {
  const lock = getRawCallLock();
  if (lock && Date.now() - lock.heartbeat > LOCK_TTL_MS) {
    localStorage.removeItem(CALL_LOCK_KEY);
  }
}

export function isCallLockedByOtherTab(): boolean {
  const lock = getCallLock();
  return !!lock && lock.tabId !== TAB_ID;
}
